import React, {useState, useContext, useEffect} from 'react';
import axios from 'axios';
import uuid from 'react-uuid';
import moment from "moment";
import {Alert, Button, Card, Col, Form, Row, Modal } from 'react-bootstrap';
import {useLocalStorage} from 'react-use';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import ReactDatetime from "react-datetime";
import EventContext from '../Visitation/context';
import {ACTIONS} from '../Visitation/action';
import {ACTIONS as EVENT_ACTION} from './Event/action';
import Reminders from './Reminders';

function Event({
  onHide,
  onSubmit,
  onRemove,
  title,
  event = null,
  scheduleId
}) {

  const {
    dispatchEvents,
    popup, dispatchPopup
  } = useContext(EventContext);

  const [auth] = useLocalStorage('authenticated');

  const handleTitleChange = ({target: {value}}) => {
    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {title: value}
    });
  }

  const handleChangeDateStart = value => {
    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {start: value}
    });
  }

  const handleChangeTimeStart = ({target: {value}}) => {
    const [hour, minute] = value.split(':');
    let newTime = popup.start;
    newTime.set({hour, minute});
    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {start: newTime}
    });
  }

  const handleChangeTimeEnd = ({target: {value}}) => {
    const [hour, minute] = value.split(':');
    let newTime = popup.end;
    newTime.set({hour, minute});
    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {end: newTime}
    });
  }

  const handleChangeDateEnd = value => {
    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {end: value}
    })
  }



  const handleSubmit = async () => {

    const response = await axios.post(
      `${process.env.REACT_APP_API_HOST}calendars`,
      {
        ...popup,
        SCHEDULE_ID: scheduleId
      },
      {headers: {Authorization: `Bearer ${auth.token}`}}
    );

    dispatchEvents({
      type: ACTIONS.CREATE,
      payload: {
        ...response.data,
        uuid: uuid(),
        start: moment(response.data.start),
        end: moment(response.data.end),
      },
    });

    onHide();
  }

  const handleUpdate = async () => {

    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}calendars/${event.id}`,
      {
        SCHEDULE_ID: scheduleId,
        ...popup,
      },
      {headers: {Authorization: `Bearer ${auth.token}`}}
    );

    dispatchEvents({
      type: ACTIONS.UPDATE,
      payload: {
        ...event,
        ...response.data,
        start: moment(response.data.start),
        end: moment(response.data.end),
      },
    });

    onHide();

  }

  const handleDelete = async () => {

    const response = await axios.delete(
      `${process.env.REACT_APP_API_HOST}calendars/${event.id}`,
      {headers: {Authorization: `Bearer ${auth.token}`}}
    );

    dispatchEvents({
      type: ACTIONS.DELETE,
      payload: event,
    });

    onHide();
  }

  return (
    <Modal
      size="lg"
      show={true}
      aria-labelledby="example-modal-sizes-title-lg"
      onHide={onHide}
    >
      {popup.start ? (
        <>
          <Modal.Body>
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Title</Form.Label>
                  <Form.Control required
                    value={popup.title}
                    onChange={handleTitleChange}
                  />
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col md="3">
                      <Form.Label>Date Start</Form.Label>
                      <ReactDatetime
                        required={true}
                        inputProps={{
                          name:"START_DATE",
                          className: "form-control",
                          placeholder: "Date Start",
                        }}
                        onChange={handleChangeDateStart}
                        value={popup.start}
                        timeFormat={false}
                        dateFormat={"YYYY-MM-DD"}
                        closeOnSelect={true}
                      />
                    </Col>
                    <Col md="2">
                      <Form.Group>
                        <Form.Label>Time Start</Form.Label>
                        <Form.Control type="time"
                          value={popup.start.format(`HH:mm`)}
                          onChange={handleChangeTimeStart}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="2">
                      <Form.Group>
                        <Form.Label>Time End</Form.Label>
                        <Form.Control type="time"
                          value={popup.end.format(`HH:mm`)}
                          onChange={handleChangeTimeEnd}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Label>Date End</Form.Label>
                      <ReactDatetime
                        required={true}
                        inputProps={{
                          name:"END_DATE",
                          className: "form-control",
                          placeholder: "Date END",
                        }}
                        onChange={handleChangeDateEnd}
                        value={popup.end}
                        timeFormat={false}
                        dateFormat={"YYYY-MM-DD"}
                        closeOnSelect={true}
                      />
                    </Col>
                  </Row>
                </Form.Group>
                <Reminders />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: 'flex-end', gap: '10px' }}>
            {event
              ? (
                <>
                  <Button variant="success" onClick={handleUpdate}>Update</Button>
                  <Button variant="danger" onClick={handleDelete}>Delete</Button>
                </>
              )
              : <Button variant="primary" onClick={handleSubmit}>Submit</Button>
            }
            <Button variant="secondary" onClick={onHide} >Close</Button>
          </Modal.Footer>
        </>
      ) : <p>Loading</p>
    }
    </Modal>
  )
}

export default Event;